import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messageList", "messageInput", "sendButton"]
  static values = {
    conversationId: String,
    pollInterval: { type: Number, default: 10000 }
  }

  connect() {
    this.scrollToBottom()
    this.startPolling()
    this.setupKeyboardShortcut()
  }

  disconnect() {
    this.stopPolling()
  }

  scrollToBottom() {
    if (this.hasMessageListTarget) {
      const list = this.messageListTarget
      list.scrollTop = list.scrollHeight
    }
  }

  startPolling() {
    if (this.conversationIdValue) {
      this.pollTimer = setInterval(() => {
        this.checkForNewMessages()
      }, this.pollIntervalValue)
    }
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
  }

  async checkForNewMessages() {
    if (!this.conversationIdValue) return

    try {
      const response = await fetch(`/admin/inbox/${this.conversationIdValue}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (data.new_messages) {
          // Reload the message list
          window.location.reload()
        }
      }
    } catch (error) {
      console.error("Failed to check for new messages:", error)
    }
  }

  setupKeyboardShortcut() {
    if (this.hasMessageInputTarget) {
      this.messageInputTarget.addEventListener("keydown", (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault()
          this.sendMessage()
        }
      })
    }
  }

  async sendMessage() {
    if (!this.hasMessageInputTarget) return

    const content = this.messageInputTarget.value.trim()
    if (!content) return

    // Disable button while sending
    if (this.hasSendButtonTarget) {
      this.sendButtonTarget.disabled = true
      this.sendButtonTarget.textContent = "Sending..."
    }

    try {
      const response = await fetch(`/admin/inbox/${this.conversationIdValue}/send_message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ message: { content: content } })
      })

      if (response.ok) {
        // Clear input and reload
        this.messageInputTarget.value = ""
        window.location.reload()
      } else {
        alert("Failed to send message. Please try again.")
      }
    } catch (error) {
      console.error("Failed to send message:", error)
      alert("Failed to send message. Please try again.")
    } finally {
      if (this.hasSendButtonTarget) {
        this.sendButtonTarget.disabled = false
        this.sendButtonTarget.textContent = "Send"
      }
    }
  }

  expandInput() {
    if (this.hasMessageInputTarget) {
      const input = this.messageInputTarget
      input.style.height = "auto"
      input.style.height = Math.min(input.scrollHeight, 150) + "px"
    }
  }

  attachFile() {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = "image/*,video/*,.pdf,.doc,.docx"
    input.onchange = (event) => {
      const file = event.target.files[0]
      if (file) {
        this.uploadFile(file)
      }
    }
    input.click()
  }

  async uploadFile(file) {
    const formData = new FormData()
    formData.append("file", file)

    try {
      const response = await fetch(`/admin/inbox/${this.conversationIdValue}/send_message`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: formData
      })

      if (response.ok) {
        window.location.reload()
      }
    } catch (error) {
      console.error("Failed to upload file:", error)
    }
  }
}
